import { Element, Text } from "hast";
import { Node } from "unist";

export async function loadScript(src: string, head = false, defer = false) {
  const script = document.createElement("script");
  const promise = new Promise<string>((resolve) =>
    script.addEventListener("load", () => resolve(src))
  );
  script.src = src;
  script.setAttribute(defer ? "defer" : "async", "");
  document[head ? "head" : "body"].append(script);
  return promise;
}

export function inlineScript(text: string) {
  const script = document.createElement("script");
  script.text = text;
  document.body.append(script);
  return Promise.resolve<string>(text);
}

export async function loadStyle(href: string, head = false) {
  const link = document.createElement("link");
  const promise = new Promise<string>((resolve) =>
    link.addEventListener("load", () => resolve(href))
  );
  link.href = href;
  link.rel = "stylesheet";
  document[head ? "head" : "body"].append(link);
  return promise;
}

export function hasProperty<T extends Element | undefined, K extends string>(
  obj: T,
  key: K
): obj is T & { properties: Record<K, string> } {
  return (
    obj != undefined && obj.properties != undefined && key in obj.properties
  );
}

export function isText(el: Node): el is Text {
  return el.type === "text";
}
